export function getPreventAutofillProps() {
  return {
    autoComplete: 'new-password',
    'data-lpignore': 'true',
    'data-1p-ignore': true,
    'data-form-type': 'other',
    'data-bwignore': true
  }
}
